(function() {
    'use strict';
    
    /**
     * Service de données simulées pour l'application
     * Cela permet d'avoir des données représentatives sans appel à l'API backend
     */
    angular
        .module('observatoireApp')
.factory('MockDataService', function() {
  
  // Données simulées pour les jeux de données
  const datasets = [
    {
      id: 1,
      title: "Tableau des Opérations Financières de l'État (TOFE) - 2025",
      description: "Données complètes du TOFE pour l'année fiscale 2025 incluant recettes, dépenses et financement",
      organization: "Ministère des Finances",
      createdAt: "2025-01-10",
      updatedAt: "2025-04-25",
      tags: ["TOFE", "finances publiques", "budget", "2025"],
      resources: 7,
      views: 3150,
      downloads: 945,
      isFeatured: true,
      status: "Published",
      image: "assets/images/placeholders/dataset-budget.svg"
    },
    {
      id: 2,
      title: "Budget de l'État 2025",
      description: "Données détaillées du budget de l'État tchadien pour l'année fiscale 2025, incluant les recettes fiscales et les dépenses budgétaires",
      organization: "Ministère des Finances",
      createdAt: "2025-02-10",
      updatedAt: "2025-04-30",
      tags: ["budget", "finances", "recettes fiscales", "dépenses publiques", "2025"],
      resources: 8,
      views: 3280,
      downloads: 1045,
      isFeatured: true,
      status: "Published",
      image: "assets/images/placeholders/dataset-budget.svg"
    },
    {
      id: 3,
      title: "Budget national du Tchad 2024",
      description: "Données du budget national du Tchad pour l'année fiscale 2024 incluant les recettes et dépenses par ministère",
      organization: "Ministère des Finances",
      createdAt: "2024-01-15",
      updatedAt: "2024-03-20",
      tags: ["budget", "finances", "dépenses publiques"],
      resources: 5,
      views: 2456,
      downloads: 872,
      isFeatured: false,
      status: "Published",
      image: "assets/images/placeholders/dataset-budget.svg"
    },
    {
      id: 3,
      title: "Production pétrolière 2020-2023",
      description: "Statistiques trimestrielles de la production pétrolière du Tchad entre 2020 et 2023",
      organization: "Ministère du Pétrole",
      createdAt: "2023-11-05",
      updatedAt: "2024-02-10",
      tags: ["pétrole", "production", "énergie"],
      resources: 8,
      views: 1892,
      downloads: 634,
      isFeatured: true,
      status: "Published",
      image: "assets/images/placeholders/dataset-petrole.svg"
    },
    {
      id: 4,
      title: "Statistiques d'éducation nationale 2023",
      description: "Données sur les établissements scolaires, le nombre d'élèves et d'enseignants par région",
      organization: "Ministère de l'Éducation",
      createdAt: "2023-12-18",
      updatedAt: "2024-01-30",
      tags: ["éducation", "écoles", "statistiques"],
      resources: 12,
      views: 1245,
      downloads: 520,
      isFeatured: false,
      status: "Published",
      image: "assets/images/placeholders/dataset-education.svg"
    },
    {
      id: 5,
      title: "Importations et exportations 2023",
      description: "Données sur les importations et exportations du Tchad par catégorie de produits et pays partenaires",
      organization: "Direction Générale des Douanes",
      createdAt: "2024-02-05",
      updatedAt: "2024-02-28",
      tags: ["commerce", "douanes", "économie"],
      resources: 6,
      views: 986,
      downloads: 317,
      isFeatured: false,
      status: "Draft",
      image: "assets/images/placeholders/dataset-commerce.svg"
    },
    {
      id: 6,
      title: "Investissements publics par région 2023",
      description: "Répartition des investissements publics par région et par secteur",
      organization: "Ministère du Plan",
      createdAt: "2023-10-22",
      updatedAt: "2024-01-15",
      tags: ["investissements", "développement", "régions"],
      resources: 4,
      views: 756,
      downloads: 289,
      isFeatured: true,
      status: "Published",
      image: "assets/images/placeholders/dataset-investissement.svg"
    },
    {
      id: 7,
      title: "Statistiques sanitaires 2023",
      description: "Données sur les infrastructures de santé, le personnel médical et les indicateurs sanitaires",
      organization: "Ministère de la Santé",
      createdAt: "2023-12-10",
      updatedAt: "2024-02-22",
      tags: ["santé", "hôpitaux", "statistiques"],
      resources: 9,
      views: 1102,
      downloads: 476,
      isFeatured: false,
      status: "Published",
      image: "assets/images/placeholders/dataset-sante.svg"
    }
  ];
  
  // Données simulées pour les organisations
  const organizations = [
    {
      id: 1,
      name: "Ministère des Finances",
      description: "Le Ministère des Finances du Tchad est responsable de la gestion des finances publiques, de l'élaboration et de l'exécution du budget national.",
      createdAt: "2021-06-15",
      logo: "assets/images/placeholders/logo-finances.svg",
      datasets: 12,
      members: 8,
      followers: 345,
      website: "https://finances.gouv.td",
      type: "government"
    },
    {
      id: 2,
      name: "Ministère du Pétrole",
      description: "Le Ministère du Pétrole supervise l'exploitation des ressources pétrolières du Tchad et gère les relations avec les compagnies pétrolières.",
      createdAt: "2022-02-10",
      logo: "assets/images/placeholders/logo-petrole.svg",
      datasets: 8,
      members: 6,
      followers: 287,
      website: "https://petrole.gouv.td",
      type: "government"
    },
    {
      id: 3,
      name: "Direction Générale des Douanes",
      description: "La Direction Générale des Douanes est chargée de la perception des droits et taxes à l'importation et à l'exportation ainsi que de la lutte contre la fraude.",
      createdAt: "2021-09-28",
      logo: "assets/images/placeholders/logo-douanes.svg",
      datasets: 6,
      members: 5,
      followers: 210,
      website: "https://douanes.gouv.td",
      type: "government"
    },
    {
      id: 4,
      name: "Banque des États de l'Afrique Centrale (BEAC)",
      description: "La BEAC est la banque centrale commune aux États membres de la CEMAC, dont le Tchad fait partie.",
      createdAt: "2020-11-05",
      logo: "assets/images/placeholders/logo-beac.svg",
      datasets: 10,
      members: 7,
      followers: 420,
      website: "https://www.beac.int",
      type: "bank"
    },
    {
      id: 5,
      name: "Institut National de la Statistique, des Études Économiques et Démographiques (INSEED)",
      description: "L'INSEED est l'organisme officiel chargé de la production et de la diffusion des statistiques nationales au Tchad.",
      createdAt: "2021-03-12",
      logo: "assets/images/placeholders/logo-inseed.svg",
      datasets: 15,
      members: 12,
      followers: 368,
      website: "https://www.inseed.td",
      type: "government"
    }
  ];
  
  // Données simulées pour les publications
  const publications = [
    {
      id: 1,
      title: "Rapport annuel sur l'exécution du budget 2023",
      description: "Ce rapport présente l'analyse détaillée de l'exécution du budget national du Tchad pour l'année 2023.",
      organization: "Ministère des Finances",
      author: "Direction Générale du Budget",
      publicationDate: "2024-02-28",
      type: "rapport",
      coverImage: "assets/images/placeholders/pub-budget.svg",
      pdfUrl: "#",
      tags: ["budget", "finances publiques", "rapport annuel"]
    },
    {
      id: 2,
      title: "État des lieux du secteur pétrolier au Tchad",
      description: "Une analyse complète du secteur pétrolier tchadien, incluant la production, les revenus et les perspectives.",
      organization: "Ministère du Pétrole",
      author: "Direction des Études et de la Planification",
      publicationDate: "2023-12-15",
      type: "étude",
      coverImage: "assets/images/placeholders/pub-petrole.svg",
      pdfUrl: "#",
      tags: ["pétrole", "ressources naturelles", "économie"]
    },
    {
      id: 3,
      title: "Guide de la transparence budgétaire",
      description: "Un guide pratique sur les mécanismes de transparence budgétaire et l'accès aux informations financières publiques.",
      organization: "Observatoire Tchadien des Finances Publiques",
      author: "Comité de Transparence",
      publicationDate: "2023-10-05",
      type: "guide",
      coverImage: "assets/images/placeholders/pub-transparence.svg",
      pdfUrl: "#",
      tags: ["transparence", "budget", "guide pratique"]
    },
    {
      id: 4,
      title: "Rapport sur la dette publique du Tchad",
      description: "Analyse de l'état actuel de la dette publique tchadienne et des stratégies de gestion.",
      organization: "Ministère des Finances",
      author: "Direction de la Dette Publique",
      publicationDate: "2024-01-20",
      type: "rapport",
      coverImage: "assets/images/placeholders/pub-dette.svg",
      pdfUrl: "#",
      tags: ["dette", "finances publiques", "économie"]
    }
  ];
  
  // Données simulées pour les secteurs
  const statistics = {
    datasets: 76,
    organizations: 28,
    downloads: 15890,
    views: 56728
  };
  
  // Données simulées pour les graphiques
  const chartData = {
    budget: {
      labels: ["Éducation", "Santé", "Infrastructure", "Défense", "Agriculture", "Autres"],
      data: [25, 18, 22, 15, 10, 10],
      colors: [
        "#4e5bc4",
        "#6c30a8",
        "#9d32a8", 
        "#2a3990", 
        "#1475bb",
        "#5a6acf"
      ]
    },
    budget2025: {
      recettes: {
        labels: ["Recettes fiscales", "Dons et legs", "Autres recettes"],
        data: [1248600000, 193800000, 442400000],
        colors: ["#4e5bc4", "#6c30a8", "#2a3990"]
      },
      depenses: {
        labels: ["Personnel", "Biens et services", "Transferts", "Investissement", "Charges financières"],
        data: [1020000000, 1020000000, 836256114.7, 1196100000, 15490500],
        colors: ["#6c30a8", "#9d32a8", "#2a3990", "#1475bb", "#5a6acf"]
      }
    },
    
    petroleumProduction: {
      labels: ["Trim 1", "Trim 2", "Trim 3", "Trim 4"],
      datasets: [
        {
          label: "2022",
          data: [120, 135, 142, 138],
          borderColor: "#2a3990"
        },
        {
          label: "2023",
          data: [145, 152, 160, 155],
          borderColor: "#6c30a8"
        }
      ]
    },
    revenueDistribution: {
      labels: ["Impôts", "Recettes pétrolières", "Douanes", "Aides internationales", "Autres"],
      data: [35, 28, 15, 12, 10],
      colors: [
        "#4e5bc4",
        "#6c30a8",
        "#2a3990", 
        "#1475bb",
        "#5a6acf"
      ]
    }
  };
  
  // Méthodes du service
  return {
    // Récupérer tous les jeux de données
    getAllDatasets: function() {
      return angular.copy(datasets);
    },
    
    // Récupérer les jeux de données mis en avant
    getFeaturedDatasets: function() {
      return angular.copy(datasets.filter(d => d.isFeatured));
    },
    
    // Récupérer un jeu de données par son ID
    getDatasetById: function(id) {
      return angular.copy(datasets.find(d => d.id === id));
    },
    
    // Récupérer toutes les organisations
    getAllOrganizations: function() {
      return angular.copy(organizations);
    },
    
    // Récupérer les organisations principales
    getTopOrganizations: function() {
      return angular.copy(organizations.slice(0, 3));
    },
    
    // Récupérer une organisation par son ID
    getOrganizationById: function(id) {
      return angular.copy(organizations.find(o => o.id === id));
    },
    
    // Récupérer toutes les publications
    getAllPublications: function() {
      return angular.copy(publications);
    },
    
    // Récupérer les publications récentes
    getRecentPublications: function() {
      return angular.copy(publications.slice(0, 4));
    },
    
    // Récupérer les statistiques globales
    getStatistics: function() {
      return angular.copy(statistics);
    },
    
    // Récupérer les données des graphiques
    getChartData: function() {
      return angular.copy(chartData);
    }
  };
});

})();
